import { Component } from '@angular/core';

@Component({
  templateUrl: 'parameters.component.html'
})
export class ParametersComponent {

  constructor() { 

  } 
}


// WEBPACK FOOTER //
// ./src/app/systems/parameters.component.ts